import { ColumnDef } from "@tanstack/react-table";
import { InterestJourney } from "../types";
import Status from "@/modules/common/components/ui-kit/status/status";
import UserCell from "@/modules/common/components/ui/user-cell";
import { format } from "date-fns";

export const interestsColumns: ColumnDef<InterestJourney>[] = [
  {
    id: "leadName",
    header: "Lead name",
    accessorFn: (row) => row.journey.customer.name,
  },
  {
    id: "customerNumber",
    header: "Phone Number",
    accessorFn: (row) => row.journey.customer.telephones?.[0]?.telephone,
  },
  {
    id: "leadStatus",
    header: "Status",
    cell: ({ row }) => {
      return <Status label={row.original.journey.status.name} width="auto" />;
    },
  },
  {
    id: "lastAction",
    header: "Interest Action",
    cell: ({ row }) => {
      return (
        <Status
          label={row.original.lastAction?.interestActionType.name}
          width="auto"
          bgHexColor={row.original.lastAction?.interestActionType.color}
        />
      );
    },
  },
  {
    id: "leadAssignedAgent",
    header: "Assigned Agent",
    cell: ({ row }) => (
      <UserCell
        name={row.original.journey.user?.name}
        color={row.original.journey.user?.color}
      />
    ),
  },
  {
    id: "interestCreator",
    header: "Creator",
    cell: ({ row }) => (
      <UserCell
        name={row.original.addedBy?.name}
        color={row.original.addedBy?.color}
      />
    ),
  },
  {
    id: "dateAdded",
    header: "Date Added",
    accessorFn: (row) => row?.createdAt,
    cell: ({ row }) => {
      const createdAt = row.original?.createdAt;
      return createdAt ? format(new Date(createdAt), "dd/MM/yyyy") : "N/A";
    },
  },
];
